const setCacheControl = (res, maxAge, dateString) => {
    if (!process.browser) {
        if (maxAge > 0) {
            res.set('Cache-Control', `max-age=${maxAge}`);
        } else {
            res.set('Cache-Control', 'no-cache');
        }

        if (dateString) {
            res.set('Last-Modified', new Date(dateString).toUTCString());
        }
    }
};

export {setCacheControl};
